// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1cj3-","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3URml","obliqueLine":"membershipbadge_obliqueLine__1fYC-"};